/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect} from 'react'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import {PageTitle} from '../../../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import {Col, Dropdown, Row, Spinner} from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import {useNavigate} from 'react-router-dom'
import JobServices from '../../../../../services/job'
import useServices from '../../../../../utils/hooks/useServices'
import useDebounce from '../../../../../utils/hooks/useDebounce'
import {toast} from 'react-toastify'

let active = 1
let items: any = []
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>
  )
}

const heads = [
  {
    name: '',
    label: 'Judul',
  },
  {
    name: '',
    label: 'Tanggal Posting',
  },
  {
    name: '',
    label: 'Total Pelamar',
  },
  {
    name: '',
    label: 'Status',
  },
  {
    name: '',
    label: 'Aksi',
  },
]

const StatusComponent = (status: string) => {
  switch (status) {
    case '0':
      return (
        <Button
          className='shadow-none btn btn-sm btn-outline btn-outline-success'
          variant='outline'
        >
          Menunggu Verifikasi
        </Button>
      )
    case '1':
      return (
        <Button
          className='shadow-none btn btn-sm btn-outline btn-outline-success'
          variant='outline'
        >
          Akfif
        </Button>
      )
    case '2':
      return (
        <Button className='shadow-none btn btn-sm btn-outline btn-outline-danger' variant='outline'>
          Ditolak
        </Button>
      )
    case '3':
      return (
        <Button className='shadow-none btn btn-sm btn-outline btn-outline-dark' variant='outline'>
          Non-Aktif
        </Button>
      )
  }
}

const JobsPage: FC = () => {
  let navigate = useNavigate()
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })
  const [query, setQuery] = useState<any>({q: '', sort_order: 'desc'})
  const [jobs, loadingJobs, makeJobsEmpty, refreshJobs] = useServices(
    JobServices.getJobHash,
    {...query, page: pagination.page, per_page: pagination.per_page},
    []
  )

  useEffect(() => {
    refreshJobs()
    generateTotalPage(pagination.total_page)
  }, [pagination.per_page, pagination.page])

  useDebounce(refreshJobs, 250, [query])

  const generateTotalPage = (totalPage: number) => {
    let total = 0
    let newTotal: any = []

    for (total = 0; total < totalPage; total++) {
      newTotal.push(total + 1)
    }

    return newTotal
  }

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  const handleCloseJob = async (jobId: string) => {
    if (window.confirm('Semua pelamar tersisa akan otomatis ditolak?')) {
      await JobServices.closeJob({status: 3, id: jobId}).then(() => {
        toast.success('Lowongan berhasil ditutup.')
        refreshJobs()
        generateTotalPage(pagination.total_page)
      })
    }
  }

  const ActionComponent = (item: any) => {
    return (
      <Dropdown>
        <Dropdown.Toggle id='dropdown-basic' className='btn btn-primary btn-sm'>
          {'  '}
          Aksi
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => navigate('/applicants-job/' + item.company_jobs_id)}>
            Lihat Pelamar
          </Dropdown.Item>
          <Dropdown.Item onClick={() => navigate(`/job-search/${item.company_jobs_id}`)}>
            Detail Lowongan
          </Dropdown.Item>
          {item.company_jobs_status == 0 || item.company_jobs_status == 1 ? (
            <Dropdown.Item onClick={() => handleCloseJob(item.company_jobs_id)}>
              Tutup Lowongan
            </Dropdown.Item>
          ) : null}
        </Dropdown.Menu>
      </Dropdown>
    )
  }

  return (
    <>
      <div className='row'>
        <div className='col-md-12'>
          <div className='card-custom'>
            <div style={{float: 'right'}}></div>
            <Row>
              <Col md={{span: 4}}>
                <Form.Control
                  placeholder='Cari...'
                  name='q'
                  onChange={(e) => setQuery({...query, q: e.target.value})}
                />
              </Col>
              <Col md={{span: 2, offset: 4}}>
                <Button
                  type='button'
                  onClick={() => navigate('/create-job')}
                  className='form-control'
                >
                  Tambah
                </Button>
              </Col>
              <Col md={{span: 2}}>
                <Form.Select
                  aria-label='Default select example'
                  className='mr-8'
                  onChange={(e) => {
                    setQuery({...query, sort_order: e.target.value})
                  }}
                >
                  <option value='desc'>Terbaru</option>
                  <option value='asc'>Terlama</option>
                </Form.Select>
              </Col>
            </Row>
            <Table responsive className='table-striped align-middle mt-8'>
              <thead>
                <tr>
                  <th>#</th>
                  {heads.map((item, index) => (
                    <th key={index}>{item.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {jobs.data?.data?.length === 0 && !loadingJobs && (
                  <tr>
                    <td colSpan={5} align='center'>
                      Tidak ada Data
                    </td>
                  </tr>
                )}
                {loadingJobs ? (
                  <tr>
                    <td colSpan={5} align='center'>
                      <Spinner
                        animation='border'
                        role='status'
                        style={{height: '100px', width: '100px'}}
                      />
                    </td>
                  </tr>
                ) : (
                  jobs.data?.data?.map((item: any, key: any) => {
                    const date = new Date(item.created_at)
                    const finalDate = `${date.toLocaleString()}`
                    return (
                      <tr key={key}>
                        <td>{key + 1}</td>
                        <td>{item.company_jobs_title}</td>
                        <td>{finalDate}</td>
                        <td style={{textAlign: 'right'}}>{item.total_applicants}</td>
                        <td>{StatusComponent(item.company_jobs_status)}</td>
                        <td>{ActionComponent(item)}</td>
                      </tr>
                    )
                  })
                )}
              </tbody>
            </Table>
            {jobs?.data?.data?.length > 0 && (
              <Row>
                <Col md={6}>
                  <div style={{float: 'left'}}>
                    <Dropdown className='btn-sm'>
                      <Dropdown.Toggle className='btn-sm'>{pagination.per_page}</Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          href='#/action-1'
                          onClick={() => onChangePerPage(10)}
                          disabled={pagination.per_page === 10}
                        >
                          10
                        </Dropdown.Item>
                        <Dropdown.Item
                          href='#/action-1'
                          onClick={() => onChangePerPage(25)}
                          disabled={pagination.per_page === 25}
                        >
                          25
                        </Dropdown.Item>
                        <Dropdown.Item
                          href='#/action-2'
                          onClick={() => onChangePerPage(50)}
                          disabled={pagination.per_page === 50}
                        >
                          50
                        </Dropdown.Item>
                        <Dropdown.Item
                          href='#/action-3'
                          onClick={() => onChangePerPage(100)}
                          disabled={pagination.per_page === 100}
                        >
                          100
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </Col>
                <Col md={6}>
                  <div style={{float: 'right'}}>
                    <Pagination>
                      {generateTotalPage(jobs?.data?.last_page)?.map((item: any) => {
                        return (
                          <Pagination.Item
                            key={item}
                            active={item === pagination.page}
                            onClick={() => onChangePerPage(pagination.per_page, item)}
                          >
                            {item}
                          </Pagination.Item>
                        )
                      })}
                    </Pagination>
                  </div>
                </Col>
              </Row>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

const Jobs: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Semua Lowongan Saya
      </PageTitle>
      <JobsPage />
    </>
  )
}

export default Jobs
